// /forge/year-one — Year 1 Active phase page.
//
// Wraps existing Assignment analytics (stages 27-30 — crew assignment, fit
// test, gear issue, first duty) as the "Cohort" tab. Remaining tabs are
// placeholders; PR C fills them with compliance tracking, engagement
// (meetings/shifts), and first-year retention forecast.
//
// Previously routed at /forge/assignment — that URL now redirects here.

import PhaseTabs, { PlaceholderTab } from "../../components/shared/PhaseTabs";
import Assignment from "./Assignment";

export default function YearOneActive() {
  return (
    <PhaseTabs
      eyebrow="FORGE · Year 1 Active"
      title="Year 1 Active"
      subtitle="Probationary cohort — crew assignment, compliance, engagement, first-year retention."
      tabs={[
        {
          key: "cohort",
          label: "Probationary Cohort",
          content: <Assignment />,
        },
        {
          key: "compliance",
          label: "Compliance",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Physical status, cert currency, and training compliance for first-year members. Surfaces expirations + grace windows." />
          ),
        },
        {
          key: "engagement",
          label: "Engagement",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Meeting attendance, shift hours, and call responses for the first-year cohort. Compares against department averages for the same tenure band." />
          ),
        },
        {
          key: "retention-forecast",
          label: "Retention Forecast",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Per-member completion probability + cohort survival curve from sync/ml-survival.ts + sync/ml-applicant.ts. Alerts for members likely to separate before 12 months." />
          ),
        },
      ]}
    />
  );
}
